import React, {FC} from "react";
import BookingDates from "../../../booking/types/BookingDates";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import NcModal from "../../../ui/shared/NcModal/NcModal";
import Badge from "../../../ui/shared/Badge/Badge";
import ButtonSecondary from "../../../ui/shared/Button/ButtonSecondary";
import ButtonPrimary from "../../../ui/shared/Button/ButtonPrimary";


interface HotelPackageRoomFeedbackModalProps {
    kind: "roomAvailableWithOverbooking" | "roomNotAvailable" | "hotelNotAvailable" | "error" | null
    unavailableDates?: BookingDates[]
    overbookingDates?: BookingDates[],
    errorMessage?: string,
    isOpen: boolean,
    onClose: () => void;
    onConfirmAddRoom: () => void;
}

const HotelWizardRoomFeedbackModal: FC<HotelPackageRoomFeedbackModalProps> = ({
                                                                     kind,
                                                                     unavailableDates,
                                                                     overbookingDates,
                                                                     errorMessage,
                                                                     isOpen,
                                                                     onClose,
                                                                     onConfirmAddRoom,
                                                                 }) => {
    const t = useTranslate();

    let modalTitle;

    switch (kind) {
        case "roomNotAvailable":
            modalTitle = t("hotelDetail.roomNotAvailable");
            break;
        case "roomAvailableWithOverbooking":
            modalTitle = t("hotelDetail.roomAvailableWithOverbooking");
            break;
        case "hotelNotAvailable":
            modalTitle = t("hotelDetail.hotelNotAvailable");
            break;
        case "error":
            modalTitle = t("hotelDetail.addRoomErrorTitle");
            break;
    }

    const modalContent = (
        <div className="text-center">
            {kind === 'error' && (
                <>
                    <i className="text-9xl las la-times-circle la-fw text-red-500 mb-1"/>
                    <p className="text-1xl">{t("hotelDetail.addRoomError")}</p>
                    {errorMessage && (<Badge name={errorMessage} color="red"/>)}
                </>
            )}
            {kind === 'roomNotAvailable' && (
                <>
                    <i className="text-9xl las la-exclamation-circle la-fw text-orange-500 mb-1"/>
                    <div className="text-1xl">
                        <p>{t("hotelDetail.roomNotAvailableAt")}</p>

                        <div className="space-x-1">
                            {unavailableDates?.map((item) => (
                                <Badge key={item.fecha} name={item.fecha} color="red"/>
                            ))}
                        </div>
                    </div>
                </>
            )}

            {kind === 'hotelNotAvailable' && (
                <>
                    <i className="text-9xl las la-exclamation-circle la-fw text-orange-500 mb-1"/>
                    <p className="mb-4">
                        {t("hotelDetail.hotelNotAvailable")}
                    </p>
                </>
            )}


            {kind === 'roomAvailableWithOverbooking' && (
                <>
                    <p className="text-2xl text-orange-500 mb-1">{t("hotelDetail.roomAvailableWithOverbookingOnRequest")}</p>
                    <div className="mb-4">
                        <p>{t("hotelDetail.roomAvailableWithOverbookingAt")}</p>

                        <div className="space-x-1">
                            {overbookingDates?.map((item) => (
                                <Badge key={item.fecha} name={item.fecha} color="yellow"/>
                            ))}
                        </div>
                    </div>
                    <p>{t("hotelDetail.roomAvailableWithOverbookingConfirm")}</p>
                </>
            )}

            <div className="flex justify-between pt-8">
                <ButtonSecondary onClick={onClose}>
                    {t(kind === 'roomAvailableWithOverbooking' ? "common.actions.cancel" : "common.actions.back")}
                </ButtonSecondary>
                {kind === 'roomAvailableWithOverbooking' && (
                    <ButtonPrimary onClick={onConfirmAddRoom}>{t("common.actions.confirm")}</ButtonPrimary>)
                }
            </div>
        </div>
    );

    return (
        <NcModal
            contentExtraClass="max-w-screen-sm"
            modalTitle={modalTitle}
            renderContent={() => modalContent}
            renderTrigger={() => null}
            isOpenProp={isOpen}
            onCloseModal={onClose}
        />
    )
}

export default HotelWizardRoomFeedbackModal;
